import React, { useCallback } from 'react';
import { useRouter } from 'expo-router';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useStyle } from 'react-native-style-utilities';

import { theme } from '@sg/garnish';

import { GiftCard } from '@order/features-gift-card';
import { useTelemetry } from '@order/Telemetry';

import { useGiftCardContent } from '../../../../../hooks/useGiftCardContent';

// ─────────────────────────────────────────────────────────────────────────────

export const AccountMenuGiftCardHeader = () => {
  const router = useRouter();
  const safeAreaInsets = useSafeAreaInsets();

  const { track } = useTelemetry();
  const contentfulData = useGiftCardContent();

  // ─── Handlers ──────────────────────────────────────────────────────────────

  const handlePress = useCallback(() => {
    track('account_gift_content_selected');

    router.navigate({ pathname: '/account/gift' });
  }, [router, track]);

  // ─── Styles ────────────────────────────────────────────────────────────────

  // The card already sits 16pt in from the screen edge, so its content only needs the rest.
  const containerDynamicStyle = useStyle(
    () => ({
      paddingLeft: Math.max(safeAreaInsets.left - theme.spacing['4'], theme.spacing['6']),
      paddingRight: Math.max(safeAreaInsets.right - theme.spacing['4'], theme.spacing['6']),
    }),
    [safeAreaInsets.left, safeAreaInsets.right],
  );

  // ─────────────────────────────────────────────────────────────────────

  return (
    <GiftCard.Account.Header
      {...contentfulData}
      style={containerDynamicStyle}
      onPress={handlePress}
    />
  );
};
